import ApiService from "./apiservice";

export const MessageService = {
    GetUnreadInbox(payload) {
        return ApiService.get("message/GetUnreadInbox", payload);
    },
    GetInbox(payload) {
        return ApiService.get("message/GetInbox", payload);
    },
    GetForcedInboxCount(payload) {
        return ApiService.get("message/GetForcedInboxCount", payload);
    },
    GetForcedInbox(payload) {
        return ApiService.get("message/GetForcedInbox", payload);
    },
    GetOutbox(payload) {
        return ApiService.get("message/GetOutbox", payload);
    },
    NewMessage(payload) {
        const headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
        return ApiService.post("message/NewMessage", payload, null, headers);
    },
    MarkAsRead(params) {
        return ApiService.post("message/MarkAsRead", null, params);
    },

};